import { render } from "./SideHeader.vue?vue&type=template&id=66e88662"
import script from "./SideHeader.vue?vue&type=script&lang=js"
export * from "./SideHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__